'use client'

import { memo, useMemo } from 'react'
import { IconCheck } from '@tabler/icons-react'

import { Promotion } from 'modules/products'
import LoadingOverlay from 'shared/ui/LoadingOverlay'
import { theme } from 'shared/ui/utils/designTokens'
import { parseDateToDDMMYYYY } from 'shared/utils/date'

import { PromotionInformation } from '../../../types'

import styles from './SpecialPromotionDescription.module.scss'

const SpecialPromotionDescription = memo(
  ({
    promotion,
    promotionInformation,
    loading
  }: {
    promotion: Promotion
    promotionInformation: PromotionInformation
    loading: boolean
  }) => {
    const maxPromotionQuantity = useMemo(() => {
      return promotion.maxPromotionQuantityPerSaleOrder
    }, [promotion.maxPromotionQuantityPerSaleOrder])

    const validTo = useMemo(() => {
      return promotion.validTo
    }, [promotion.validTo])

    return (
      <div className={styles.wrapper}>
        {loading ? (
          <LoadingOverlay />
        ) : (
          <>
            <h6 className={styles.title}>
              {promotionInformation.conditionDescription}{' '}
              {promotionInformation.targetDescription}
            </h6>
            <p className={styles.label}>
              Zasady promocji:
            </p>
            {maxPromotionQuantity && (
              <p className={styles.listItem}>
                <IconCheck
                  color={theme.colors.brand.secondary}
                  width={16}
                  height={16}
                />{' '}
                Promocja ograniczona do max {maxPromotionQuantity} szt.
                produktów promocyjnych
              </p>
            )}
            {validTo && (
              <p className={styles.listItem}>
                <IconCheck
                  color={theme.colors.brand.secondary}
                  width={16}
                  height={16}
                />{' '}
                Promocja ważna tylko do {parseDateToDDMMYYYY(validTo)}
              </p>
            )}
          </>
        )}
      </div>
    )
  }
)

export default SpecialPromotionDescription
